import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { requestToggleSummary } from '../../../../actions/bookingCalendar/calendar/summary'
import requestOpenModal from '../../../../actions/Modals/requestOpenModal'
import { IStore } from '../../../../reducers'
import { getSummary } from '../../../../reducers/bookingCalendar/selectors/summary'
import closeModal from '../../../../actions/Modals/closeModal'
import { toggleCreateReservationModal } from '../../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { isLicenseValid } from '../../../../reducers/userAccount/selectors/license'
import Toolbar, { IToolbarDispatch, IToolbarProps } from './Toolbar'

const bindDispatchToProps = (dispatch: Dispatch): IToolbarDispatch => ({
  modalClose(id) {
    dispatch(closeModal(id))
  },
  modalOpen(id, element) {
    dispatch(requestOpenModal(id, element))
  },
  openAddReservationModal() {
    dispatch(toggleCreateReservationModal(true))
  },
  toggleSummary() {
    dispatch(requestToggleSummary())
  },
})

const bindStateToProps = (state: IStore): IToolbarProps => ({
  isPremium: isLicenseValid(state),
  summary: getSummary(state),
})

export default connect<any, any, any>(
  bindStateToProps,
  bindDispatchToProps,
)(Toolbar)
